import React from 'react';

import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import runModal from 'ui-library/runModal';
import DeleteWorklistsModal from 'worklists/DeleteWorklistsModal';
import {RefreshOptions} from 'worklists/WorklistActions';
import {WorklistSummary} from 'worklists/WorklistConstants';

export interface DeleteWorklistsButtonProps {
  className?: string;
  selectedWorklists: Array<WorklistSummary>;
  refreshOptions: RefreshOptions;
}

export default function DeleteWorklistsButton(props: DeleteWorklistsButtonProps): JSX.Element {
  const disabled = props.selectedWorklists.length === 0;
  const tooltipTitle = props.selectedWorklists.length === 0 ? 'Must select worklists' : 'Delete worklists';

  return (
    <Tooltip title={tooltipTitle}>
      <Button
        buttonStyle={ButtonStyle.TERTIARY_WHITE}
        className={props.className}
        disabled={disabled}
        icon="delete"
        onClick={() => {
          runModal(DeleteWorklistsModal, {
            worklists: props.selectedWorklists,
            refreshOptions: props.refreshOptions,
          });
        }}
        size={ButtonSize.SMALL}
      />
    </Tooltip>
  );
}
